// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"28705008","618":"15216f7a","659":"42cb8792","779":"8a28d66e","787":"4cf9a60e"}[chunkId] + ".chunk.js";
};